var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer-content"},[_vm._v(" tests"),_c('br'),_c('button',{on:{"click":function($event){return _vm.close()}}},[_vm._v("닫기")])])}
var staticRenderFns = []

export { render, staticRenderFns }